import { useMemo } from 'react';
import { useGetNoSelectedItemsLabel } from 'src/components/common/MultiSelect/useGetNoSelectedItemsLabel';
import { useContent } from 'src/contexts/ContentContext';
import {
  MultiSelectScope,
  NO_GROUP_ID,
  useMultiSelectionContext,
} from 'src/contexts/MultiSelectionContext';
import { ContentId } from 'src/utils/constants/contentId';

interface UseInventoryFlattedViewSelectedLegendProps {
  singleElementLabel: string;
  multipleElementsLabel: string;
  totalCount?: number;
}

export const useEventFlattedViewSelectedLegend = ({
  singleElementLabel,
  multipleElementsLabel,
  totalCount,
}: UseInventoryFlattedViewSelectedLegendProps) => {
  const { selectionMode, totalItemsSelected, itemSelection } =
    useMultiSelectionContext();
  const selectedText = useContent(ContentId.Selected);

  const isAllGroupsMode = selectionMode?.mode === MultiSelectScope.AllGroups;
  const isNoGroupSelection = !!itemSelection?.[NO_GROUP_ID];
  const noItemsSelected = useGetNoSelectedItemsLabel();

  const totalLabel =
    totalCount != null && totalCount > 0
      ? `${totalCount.toLocaleString()} ${totalCount === 1 ? singleElementLabel : multipleElementsLabel}`.toLocaleLowerCase()
      : undefined;

  return useMemo<string>(() => {
    if (!isAllGroupsMode || !totalItemsSelected || !isNoGroupSelection) {
      return totalLabel ?? noItemsSelected;
    }

    const selectedCount = itemSelection[NO_GROUP_ID].items.filter(
      (itemId) => Number(itemId) > 0
    ).length;

    if (totalLabel) {
      return `${selectedCount.toLocaleString()} of ${totalLabel} ${selectedText}`.toLocaleLowerCase();
    }

    const selectedListingsLabel = `${selectedCount} ${
      selectedCount === 1 ? singleElementLabel : multipleElementsLabel
    }`;

    return `${selectedListingsLabel} ${selectedText}`.toLocaleLowerCase();
  }, [
    isAllGroupsMode,
    totalItemsSelected,
    isNoGroupSelection,
    itemSelection,
    singleElementLabel,
    multipleElementsLabel,
    selectedText,
    totalLabel,
    noItemsSelected,
  ]);
};
